// const branchIdentifier = process.env.BRANCH_IDENTIFIER || 'develop';
const branchIdentifier = process.env.BRANCH_IDENTIFIER || 'master';
const appConfig = process.env.CONFIG || 'nonprod';
const nodeEnv = process.env.NODE_ENV || '';
const babelEnv = process.env.BABEL_ENV || '';
const deploymentVersion = process.env.DEPLOYMENT_VERSION;
const isProd = appConfig === 'prod';

const commonConfig = {
  appConfig,
  babelEnv,
  branch: branchIdentifier,
  deploymentVersion,
  nodeEnv,
  useCdn: isProd,
  fdpqApiBaseUrl: isProd ? `https://use1-${branchIdentifier}.awskbbfdpq.kbb.com` : `https://use1-${branchIdentifier}.awskbbfdpqnp.kbb.com`,
  fdpqCdnBaseUrl: isProd ? 'https://fdpq.syndication.kbb.com' : 'https://dev.awskbbfdpqnp.kbb.com',
  gtmCode: isProd ? 'GTM-KQQM5F8' : 'GTM-M23PMMN'
};

export default commonConfig;
